<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc"></h2>
<p class="firstsmall" id="Copyright">InterVarsity Press<br/>
  P.O. Box 1400<br/>
  Downers Grove, IL 60515-1426<br/>
  World Wide Web: <a href="http://www.ivpress.com" target="_blank">www.ivpress.com</a><br/>
  E-mail: <a href="mailto:email@ivpress.com">email@ivpress.com</a></p>
<p class="firstsmall">© 2013 by Robbie Fox Castleman</p>
<p class="firstsmall">All rights reserved. No part of this book may be reproduced in any form without written permission from InterVarsity Press.</p>
<p class="firstsmall">InterVarsity Press® is the book-publishing division of InterVarsity Christian Fellowship/USA®, a movement of students and faculty active on campus at hundreds of universities, colleges and schools of nursing in the United States of America, and a member movement of the International Fellowship of Evangelical Students. For information about local and regional activities, write Public Relations Dept. InterVarsity Christian Fellowship/USA, 6400 Schroeder Rd., P.O. Box 7895, Madison, WI 53707-7895, or visit the IVCF website at <a href="http://www.intervarsity.org" target="_blank">www.intervarsity.org</a>.</p>
<p class="firstsmall">Scripture quotations, unless otherwise noted, are from the <em>New Revised Standard Version of the Bible,</em> copyright 1989 by the Division of Christian Education of the National Council of the Churches of Christ in the USA. Used by permission. All rights reserved.</p>
<p class="firstsmall">While all stories in this book are true, some names and identifying information in this book have been changed to protect the privacy of the individuals involved.</p>
<p class="firstsmall">Cover design: Cindy Kiple<br/>
  Images: © Linda Steward/iStockphoto</p>
<p class="firstsmall">ISBN 978-0-8308-8429-2 (digital)<br/>
  ISBN 978-0-8308-3964-3 (print)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?50393235